<template>
    <rkm-table
        :fields="fields"
        :items="data"
        sort-by="nomeCausa"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click="handleOpenModal(item)"
                color="info"
                small
                title="Observação"
            >
                <rkm-icon icon="info-circle" />
            </rkm-button>

            <rkm-button
                @click="handleClickEdit(item)"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                :disabled="item.allowDestroy && !!item.id"
                @click="destroy(item)"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>

export default {
    data: () => ({
        fields: [
            { key: 'nomeCausa', label: 'Nome', sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
    }),
    methods: {
        handleClickEdit(causaProvavel) {

            this.$emit('editCausaProvavel', causaProvavel)
        },
        destroy(causaProvavel) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir a causa provavel?',
                async () => this.data.splice(this.data.indexOf(causaProvavel), 1)
            )
        },
        handleOpenModal(causaProvavel) {

            this.$emit('openModalObservacoes', causaProvavel)
        },
    },
    props: {
        data: { type: [Array, Object], required: true },
    },
}
</script>